import { Button, Dialog, Alert, Typography, FormControl, InputLabel, Select, MenuItem, Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { ApiRequest } from "GlobalFunctions";

export default function GuideDeliveredDialog(props: any) {
  const { setLoading, openDialog, setOpenDialog, loadList, guideId, guideCode, currentDeliveredToOffice } = props;
  const { enqueueSnackbar } = useSnackbar();

  const [deliveredToOffice, setDeliveredToOffice] = useState<number>(0);

  useEffect(() => {
    if (openDialog) {
      setDeliveredToOffice(currentDeliveredToOffice || 0);
    }
  }, [openDialog, currentDeliveredToOffice]);

  const handleSubmit = async () => {
    if (!guideId) {
      enqueueSnackbar("Error: ID de guía no disponible", { variant: "error" });
      return;
    }

    setLoading(true);

    await ApiRequest({
      url: "/guides/markGuideAsDeliveredToOffice",
      method: "post",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        guide_id: guideId,
        delivered_to_office: deliveredToOffice,
      }),
      setResponse: (response: any) => {
        if (response.status === "success") {
          enqueueSnackbar("Estado de entrega en oficina actualizado", { variant: "success" });
          setOpenDialog(false);
          loadList();
        } else {
          enqueueSnackbar(response.message || "Error al actualizar", { variant: "error" });
        }
        setLoading(false);
      },
    });
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  return (
    <Dialog open={openDialog} onClose={handleClose} maxWidth="sm" fullWidth>
      <Box sx={{ p: 3 }}>
        <div className="boxContainerHeader">
          <div className="boxContainerTitle">
            <h2 className="h2_title">Entrega de guía</h2>
            <span className="h2_subtitle">Cambiar estado de entrega en oficina</span>
          </div>
        </div>

        <Alert severity="info" sx={{ mb: 3, mt: 2 }}>
          <Typography variant="subtitle2" fontWeight="bold">
            Guía: {guideCode}
          </Typography>
          <Typography variant="body2">
            Estado actual: {currentDeliveredToOffice === 1 ? 'Entregada en oficina' : 'Pendiente por entregar en oficina'}
          </Typography>
        </Alert>

        <FormControl fullWidth sx={{ mb: 3 }}>
          <InputLabel id="delivered-to-office-select-label">Estado de entrega</InputLabel>
          <Select
            labelId="delivered-to-office-select-label"
            id="delivered-to-office-select"
            value={deliveredToOffice}
            label="Estado de entrega"
            onChange={(e) => setDeliveredToOffice(Number(e.target.value))}
          >
            <MenuItem value={0}>Pendiente por entregar en oficina</MenuItem>
            <MenuItem value={1}>Entregada en oficina</MenuItem>
          </Select>
        </FormControl>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button onClick={handleClose} variant="outlined">
            Cancelar
          </Button>
          <Button onClick={handleSubmit} variant="contained">
            Guardar
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}